import React from 'react'
import Header from '../common/components/Header'
import Footer from '../common/components/Footer'
import * as util from '../utils';

const Layout = (WrappedComponent, pageClassName) => {
  // return function ComponentProps (props: any) {
  //   return (
  //     <div className={pageClassName}>
  //       <Header {...props} />
  //       <WrappedComponent {...props} />
  //     </div>
  //   )
  // }
  return class Component extends React.Component<any, any> {
      constructor(props: any) {
          super(props);
          this.state = {
          };
      }
      async componentDidMount() {
          let search = this.props.location.search;
          const url = window.location.href.split('?')[0];
          if(window.localStorage.ticket) {
              search = window.localStorage.ticket
          }
          const authRes = await util.get(`/user/auth${!search ? '?' : search}&fromUrl=${url}`);
          if(authRes.status === 200){
              if(authRes.data) {
                  window.localStorage.user = JSON.stringify(authRes.data);
              }
              this.setState({userInfo: authRes.data})
          } else {
              window.localStorage.removeItem('user');
              this.setState({userInfo: null})
          }
      }
      render() {
          return (
              <div className={pageClassName}>
                  <Header {...this.props} {...this.state} />
                  <WrappedComponent {...this.props}  {...this.state} />
                  <Footer />
              </div>
          )
      }
  }
}

export default Layout
